// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2uNDj","content":"GlobalSearch_content__1AXfu"};